import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function DataGridTable({
  StudentLIst,
  appliedUniversities,
  appliedTimelines,
  appliedTerms,
  appliedUnit,
  appliedTeacher,
  appliedPrograms,
}) {
  const navigate = useNavigate();
  const handleRowClick = (params) => {
    // Navigate to the detail page, using the sno as a parameter
    navigate(`/individalunitreport/studentdeatilsunit`, {
      state: {
        StudentName: params.row.StudentName,
        Studentid: params.row.id,
        shealth:params.row.shealth,
        appliedUniversities: appliedUniversities,
        appliedTimelines: appliedTimelines,
        appliedTerms: appliedTerms,
        appliedUnit: appliedUnit,
        appliedTeacher: appliedTeacher,
        appliedPrograms: appliedPrograms,
      },
    }); // Pass the student ID if needed
  };

  // Define columns INSIDE the component to access props and hooks
  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
    },
    {
      field: 'StudentName',
      headerName: 'Student Name',
      width: 200,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
       
        <>{params.row.StudentName}</>
      ),
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 200,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'shealth',
      headerName: 'Student Health',
      width: 200,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const order = [
          'Extremely Behind Track',
          'Behind Track',
          'On Track',
          'Ahead of Track',
          'N/A',
        ];
        return order.indexOf(v1) - order.indexOf(v2);
      },
    },
    {
      field: 'NoOfStudentSupported',
      headerName: 'Last Engagement Date',
      width: 200,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const d1 = new Date(v1);
        const d2 = new Date(v2);
        return d1 - d2;
      },
    },
    {
      field: 'engagementactivity',
      headerName: 'Last Engagement Activity',
      width: 200,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'last_outreach',
      headerName: 'Last Outreach Date',
      width: 200,
      align: 'center',
      header: 'center',
      sortComparator: (v1, v2) => {
        const d1 = new Date(v1);
        const d2 = new Date(v2);
        return d1 - d2;
      },
    },
    {
      field: 'outreach_activity',
      headerName: 'Last Outreach Activity',
      width: 200,
      align: 'center',
      header: 'center',
    },
  ];

  // Create the rows array with a pre-calculated serial number
  const rows = (StudentLIst || []).map((item, index) => ({
    id: item.student, // Ensure 'id' is unique for DataGrid
    sno: index + 1, // Pre-calculate serial number here
    StudentName: item.full_name,
    Status: item.status,
    shealth: item.student_health,
    NoOfStudentSupported: item.last_engagement,
    engagementactivity: item.engagement_activity,
    last_outreach: item.last_outreach,
    outreach_activity: item.outreach_activity,
  }));

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        onRowClick={handleRowClick}
        localeText={{ noRowsLabel: 'No Student available' }}
        pageSizeOptions={[20, 50, 100]}
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
          },
          '& .MuiDataGrid-cell': {
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '14px',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
        }}
      />
    </div>
  );
}
